import { useContext } from "react";
import { Link } from "react-router";

import { useIsMobile } from "../../hooks/is-mobile";
import { UserSessionContext } from "../../use-user-context";
import { LoadingTopBar } from "../loading-bar";

export const Header: React.FC = () => {
  const isMobile = useIsMobile();
  const [session] = useContext(UserSessionContext);

  return (
    <header>
      <LoadingTopBar />
      <Link to="/">
        <img src="/img/logo.png" alt="ADM e.V."></img>
      </Link>
      {session && session.active && !isMobile ? (
        <div className="user-info">
          <i className="bi bi-person-square" style={{ color: "#f29104" }}></i>{" "}
          <span className="user">{session.username}</span>
        </div>
      ) : null}
    </header>
  );
};
